import React from "react";

const WeDidntBuild = () => {
  const objectives = [
    {
      title: "To bring clarity and structure where there's noise.",
    },
    {
      title: "To blend human expertise with digital precision.",
    },
    {
      title: "To deliver tangible results, not just recommendations.",
    },
  ];

  return (
    <div className="w-full bg-white py-16 lg:py-24 lg:pb-12">
      <div className="w-[88%] lg:w-[80%] mx-auto relative">
        {/* Header Section */}
        <div className="mb-12 lg:mb-16">
          <h2 className="text-[32px] lg:text-[48px] xl:text-[56px] text-[#0A1931] RoobertLight leading-[120%] mb-4">
            We didn't build OBZ to be just another consulting firm
          </h2>
          <h3 className="text-[20px] lg:text-[24px] xl:text-[28px] text-[#0A1931] RoobertMedium leading-[120%] mb-4">
            We built it because the needs had changed.
          </h3>
        </div>

        {/* Body Text */}
        <div className="mb-10 lg:mb-12 space-y-6">
          <p className="text-[16px] lg:text-[18px] text-[#0A1931] RoobertRegular leading-[140%]">
            Today, enterprises are under pressure to do more - grow revenue, improve customer engagement, modernize infrastructure, and make AI work across the business.
          </p>
          <p className="text-[16px] lg:text-[18px] text-[#0A1931] RoobertRegular leading-[140%]">
            They've invested in tools, platforms, and talent - yet still struggle to connect data and AI to real business outcomes.
          </p>
          <p className="text-[16px] lg:text-[18px] text-[#0A1931] RoobertMedium leading-[140%] font-semibold">
            We saw an opportunity:
          </p>
        </div>

        {/* Three Objective Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-16 mb-4 lg:mb-4">
          {objectives.map((objective, index) => (
            <div
              key={index}
              className="bg-fluoro-green p-6 lg:p-8 flex flex-col justify-center relative"
            >
              <p className="text-black RoobertMedium text-[16px] lg:text-[18px] leading-[140%]">
                {objective.title}
              </p>
              <div className="border-r-4 border-t-4 border-dark-blue absolute top-0 right-0 w-1/4 h-1/2"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WeDidntBuild;
